import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: 'Where is Hole In 1 available?',
    answer:
      'We\'re launching in Utah County first, with plans to expand worldwide.',
  },
  {
    question: 'What kind of prizes can I win?',
    answer:
      'Prizes include golf club sets, golf trips, and more — worth up to $3,500+. Prizes rotate daily across par-3 holes.',
  },
  {
    question: 'How do I film my own shot?',
    answer:
      'It\'s best to have a friend film for you, but you can also film on your own — as long as the video captures you hitting the ball and zooms in to show the ball going in the hole.',
  },
  {
    question: 'How do you verify a hole-in-one?',
    answer:
      'Every shot is recorded on video through the app. Our team reviews submissions to verify legitimate hole-in-ones before awarding prizes.',
  },
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-28 sm:py-36 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white rounded-xl border border-gray-100 overflow-hidden"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                >
                  <span className="font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`flex-shrink-0 text-gray-400 transition-transform duration-200 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
